import { useImpactScoreWeights } from '@/api/settings';

export const isCustomImpactScoresEnabled = (
  customScoringModelEnabled: boolean | undefined,
): boolean => customScoringModelEnabled === true;

export const useCustomImpactScoresEnabled = (): boolean => {
  const { settings } = useImpactScoreWeights();

  return isCustomImpactScoresEnabled(settings?.customScoringModelEnabled);
};
